import { clsx } from 'clsx';
import { createStyle } from 'game/lib/createStyles';
import { colors } from 'game/styles/theme';

export const linkStyles: React.CSSProperties = {
  font: 'inherit',
  margin: 0,
  padding: 0,
  display: 'inline',
  color: colors.blue,
  textDecoration: 'underline',
};

export const linkClass = createStyle('link', linkStyles);

interface LinkButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
}

export const LinkButton: React.FC<LinkButtonProps> = ({ className, ...rest }) => (
  <button type="button" className={clsx(linkClass, className)} {...rest} />
);
